export default "__VITE_ASSET__CdlncKng__"